import { FeatureFlag } from "types/Entity";

export type AnalyticsProvider = "omni" | "explo";

export const EXPLO_ANALYTICS_FLAGS: FeatureFlag[] = [
  FeatureFlag.EXPLO_DASHBOARDS_VIEW,
  FeatureFlag.BESPOKE_EXPLO_DASHBOARDS_VIEW,
  FeatureFlag.STANDARD_EXPLO_DASHBOARDS_VIEW,
];

export const OMNI_ANALYTICS_FLAGS: FeatureFlag[] = [
  FeatureFlag.BESPOKE_DASHBOARDS_VIEW,
  FeatureFlag.STANDARD_DASHBOARDS_VIEW,
];

export const ANALYTICS_FLAGS: FeatureFlag[] = [
  ...EXPLO_ANALYTICS_FLAGS,
  ...OMNI_ANALYTICS_FLAGS,
];

export const getAnalyticsProvider = (
  flags: Partial<Record<FeatureFlag, boolean>>
): AnalyticsProvider | null => {
  if (OMNI_ANALYTICS_FLAGS.some((flag) => flags[flag])) {
    return "omni";
  }
  if (EXPLO_ANALYTICS_FLAGS.some((flag) => flags[flag])) {
    return "explo";
  }
  return null;
};
